import { useCallback } from 'react'
import { UpdateIllustrationIcon } from '@weblite/icons'
import { Stack, styled, Typography } from '@mui/material'
import { BottomDrawer } from '$common/bottom-drawer'
import { SecondaryButton } from '$common/buttons'
import { nothing } from '$func/utils'
import { DownloadIcon } from '$common/icons'
import { t } from '$i18n'

const StyledBottomDrawer = styled(BottomDrawer)`
  z-index: ${({ theme }) => theme.zIndex.tooltip + 2};
`

const ButtonsContainer = styled('div')`
  display: flex;
  flex-direction: column;
  margin-top: auto;
  padding: 20px;
`

export interface Props {
  isOpen: boolean
}
// @ts-ignore
const downloadTwaSrc = import.meta.env.VITE_TWA_DOWNLOAD_SRC

export function ForceUpdateTwa({ isOpen }: Props) {
  if (!isOpen) return null

  const handleOnConfirm = useCallback(async () => {
    await window.open(downloadTwaSrc, '_blank')
  }, [])

  return (
    <StyledBottomDrawer isFullscreen isOpen onClose={nothing}>
      <Stack
        sx={{
          padding: '64px 20px',
          boxSizing: 'border-box',
          gap: '16px',
        }}
      >
        <UpdateIllustrationIcon
          sx={{ width: '240px', height: '180px', margin: 'auto' }}
        />
        <Typography
          variant="h2"
          dir="auto"
          marginTop="32px"
          sx={{
            overflowWrap: 'break-word',
            wordWrap: 'break-word',
            wordBreak: 'break-word',
            whiteSpace: 'pre-wrap',
            textAlign: 'center',
          }}
        >
          {t('forceUpdateTwa.title')}
        </Typography>

        <Typography
          variant="paragraph1"
          dir="auto"
          sx={{
            overflowWrap: 'break-word',
            wordWrap: 'break-word',
            wordBreak: 'break-word',
            whiteSpace: 'pre-wrap',
            textAlign: 'center',
          }}
        >
          {t('forceUpdateTwa.description')}
        </Typography>
      </Stack>
      <ButtonsContainer>
        <SecondaryButton
          text={t('forceUpdateTwa.button')}
          onClick={handleOnConfirm}
          startIcon={
            <DownloadIcon
              sx={{ width: '24px', height: '24px', color: 'neutral800' }}
            />
          }
        />
      </ButtonsContainer>
    </StyledBottomDrawer>
  )
}
